module.exports = "<div id={{$ctrl.cbName}}> <div uib-carousel active=$ctrl.active interval=$ctrl.myInterval> <div uib-slide ng-repeat=\"item in $ctrl.cbItems\" index=$index> <a href=\"{{item.url ? item.url : '#'}}\" title={{item.title}}> <img ng-src={{item.imageUrl}} target=\"{{item.url ? '_blank': '_self'}}\" class=img-responsive> </a> <div class=carousel-caption> </div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/banners/carousel-banner/templates/carousel-banner-base.view.html
 ** module id = 872
 ** module chunks = 7
 **/